var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 21.0001H5.25C5.05109 21.0001 4.86032 20.921 4.71967 20.7804C4.57902 20.6397 4.5 20.449 4.5 20.2501V3.75006C4.5 3.55115 4.57902 3.36038 4.71967 3.21973C4.86032 3.07908 5.05109 3.00006 5.25 3.00006H14.25L19.5 8.25006V20.2501C19.5 20.449 19.421 20.6397 19.2803 20.7804C19.1397 20.921 18.9489 21.0001 18.75 21.0001Z",
    stroke: "#2A3842",
    strokeWidth: 1.52674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3.00006V8.25006H19.5",
    stroke: "#2A3842",
    strokeWidth: 1.52674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.875L12 11.25L14.625 13.875",
    stroke: "#2A3842",
    strokeWidth: 1.52674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.25V11.25",
    stroke: "#2A3842",
    strokeWidth: 1.52674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequest);
export default __webpack_public_path__ + "static/media/iconRequest.cf8f8510e4880c4e2ec8463f5e64b31a.svg";
export { ForwardRef as ReactComponent };